import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * True when the signed-in user belongs to a demo/sandbox company.
 * Demo workspaces are read-only: they can browse the sample data but cannot
 * add, edit or delete customers, crew, or invites.
 */
export function useIsDemoCompany() {
  const [isDemo, setIsDemo] = useState(false);

  useEffect(() => {
    let active = true;
    supabase.rpc("current_company_is_demo").then(({ data }) => {
      if (active) setIsDemo(data === true);
    });
    return () => {
      active = false;
    };
  }, []);

  return isDemo;
}
